import { render, staticRenderFns } from "./openAccount.vue?vue&type=template&id=2909f272&scoped=true&"
import script from "./openAccount.vue?vue&type=script&lang=js&"
export * from "./openAccount.vue?vue&type=script&lang=js&"
import style0 from "./openAccount.vue?vue&type=style&index=0&id=2909f272&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909f272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2909f272', component.options)
    } else {
      api.reload('2909f272', component.options)
    }
    module.hot.accept("./openAccount.vue?vue&type=template&id=2909f272&scoped=true&", function () {
      api.rerender('2909f272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/openAccount.vue"
export default component.exports